import { Controller } from '@hotwired/stimulus'
import { Toast } from 'bootstrap'

export default class extends Controller {
  connect() {
    console.log('toast controller connected')
    const toast = new Toast(this.element, {
      autohide: true,
      delay: 5000
    })
    toast.show()

    // Remove the element after it's hidden to keep DOM clean
    this.element.addEventListener('hidden.bs.toast', () => {
      this.element.remove()
    })
  }
}
